'use client'

import React from 'react'
import LanguageSwitcher from '../LanguageSwitcher'

interface HeaderMobileProps {
  mobileMenuOpen: boolean
  setMobileSubmenuOpen: (value: string | null) => void
  handleMobileMenuLinkClick: (e: React.MouseEvent, url: string) => void
  isI18n: boolean
  t: (key: string) => string
}

/**
 * Header Mobile Menu Component
 * Mobile overlay menu with navigation links
 */
export function HeaderMobile({
  mobileMenuOpen,
  setMobileSubmenuOpen,
  handleMobileMenuLinkClick,
  isI18n,
  t,
}: HeaderMobileProps) {
  return (
    <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`} data-mobile-menu>
      <div className="mobile-menu-backdrop" />

      <div className="mobile-menu-content">
        {/* Language Switcher at TOP of mobile menu */}
        {isI18n && (
          <div className="mobile-menu-language">
            <LanguageSwitcher />
          </div>
        )}

        <nav className="mobile-menu-nav">
          <a
            href="/"
            className="mobile-menu-link"
            onClick={(e) => handleMobileMenuLinkClick(e, '/')}
          >
            {t('home')}
          </a>
          <button
            className="mobile-menu-link"
            onClick={() => setMobileSubmenuOpen('lodges')}
          >
            {t('lodges')}
          </button>
          <button
            className="mobile-menu-link"
            onClick={() => setMobileSubmenuOpen('adventures')}
          >
            {t('adventures')}
          </button>
          <button
            className="mobile-menu-link"
            onClick={() => setMobileSubmenuOpen('experiences')}
          >
            {t('experiences')}
          </button>
          <a
            href="/events"
            className="mobile-menu-link"
            onClick={(e) => handleMobileMenuLinkClick(e, '/events')}
          >
            {t('events')}
          </a>
          <a
            href="/testimonials"
            className="mobile-menu-link"
            onClick={(e) => handleMobileMenuLinkClick(e, '/testimonials')}
          >
            {t('testimonials')}
          </a>
          <a
            href="/why-apex"
            className="mobile-menu-link"
            onClick={(e) => handleMobileMenuLinkClick(e, '/why-apex')}
          >
            {t('whyApex')}
          </a>
          <a
            href="/contact"
            className="mobile-menu-link"
            onClick={(e) => handleMobileMenuLinkClick(e, '/contact')}
          >
            {t('contact')}
          </a>
        </nav>

        <div className="mobile-menu-cta">
          <a
            href="/booking"
            className="mobile-menu-book"
            onClick={(e) => handleMobileMenuLinkClick(e, '/booking')}
          >
            {t('bookNow').toUpperCase()}
          </a>
        </div>
      </div>
    </div>
  )
}
